import React, { useState, useMemo } from 'react';
import MUIDataTable from 'mui-datatables';

import CustomToolbar from 'components/CustomToolbar/CustomToolbar';

import { standard } from 'constants/userAccountTypes';

const CustomersTable = (props) => {

  const [rowsSelected, setRowsSelected] = useState([]);

  const tableData = useMemo(() => {
    const initialTableData = [];
    
    for ( let i = 0; i < props.customers.length; i++ ) {
      const customer = props.customers[i];
      initialTableData.push({
        displayId: customer.displayId,
        name: customer.name,
        phone: customer.phone,
        address: `${customer.city}, ${customer.country}`,
        company: customer.trn ? "Yes" : "No"
      });
    }

    return initialTableData;
  
  }, [props.customers]);

  const columns = [
    { label: "ID", name: "displayId"},
    { label: "Name", name: "name"},
    { label: "Phone", name: "phone" },
    { label: "Address", name: "address" },
    { label: "Company", name: "company" }
  ];

  const onRowSelectionChange = (curr, all, rowsSelected) => {
    setRowsSelected(rowsSelected);
    if(rowsSelected.length === 1) {
      const customerInfo = props.customers[rowsSelected[0]];
      props.setUpdateInfo({
        id: customerInfo.id,
        name: customerInfo.name,
        phone: customerInfo.phone,
        addressLine: customerInfo.addressLine,
        city: customerInfo.city,
        country: customerInfo.country,
        trn: customerInfo.trn ? customerInfo.trn : ""
      });
    }
  };

  const customToolbarSelect = () => {
    return (
      <CustomToolbar
        switchy={1}
        element="Customer"
        setUpdate={props.updateCustomer}
      />
    )
  };

  const ownerAdminOptions = {
    filterType: 'checkbox',
    selectableRows: 'none'
  };

  const standardOptions = {
    filterType: 'checkbox',
    selectableRows: 'single',
    selectableRowsOnClick: true,
    rowsSelected,
    onRowSelectionChange,
    customToolbarSelect
  };

  return(
    <MUIDataTable
      title={"Customer List"}
      data={tableData}
      columns={columns}
      options={props.activeUserType === standard ? standardOptions : ownerAdminOptions}
    />
  )
};

export default CustomersTable;